/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IDictionary, IModuleContract, IPageResponse } from '@msdyn365-commerce/core-internal';

interface IPageResponseWithModules extends IPageResponse {
    modules: IDictionary<IModuleContract>;
}

function getFlattenedListOfChildren(slot: IModuleContract, fragmentId?: string): IModuleContract[] {
    if (!slot) {
        return [];
    }

    let slotArr: IModuleContract[] = [slot];
    slot.modules &&
        Object.values(slot.modules).forEach((current: IModuleContract[]) => {
            if (current) {
                current.forEach(m => {
                    if (fragmentId) {
                        m.id = `${fragmentId}__${m.id}`;
                    }
                    slotArr = slotArr.concat(getFlattenedListOfChildren(m, fragmentId));
                });
            }
        });
    return slotArr;
}

export function getFlattenedListOfModulesForFragment(fragment: IModuleContract, fragmentId: string): IModuleContract[] {
    if (!fragment) {
        return [];
    }
    return getFlattenedListOfChildren(fragment, fragmentId);
}

export function getFlattenedListOfModules(pageResponse: IPageResponse): IModuleContract[] {
    if (!pageResponse) {
        return [];
    }
    const response = <IPageResponseWithModules>pageResponse;
    const propValue = response.slots;
    if (propValue) {
        return propValue;
    }

    const modulesFromLegacy = response.modules && Object.values(response.modules);
    if (modulesFromLegacy && modulesFromLegacy.length) {
        return modulesFromLegacy.map((m: IModuleContract) => m);
    } else {
        return getFlattenedListOfChildren(pageResponse.pageRoot);
    }
}
